import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const Layout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className={`app${sidebarOpen ? " sidebar-open" : ""}`}>
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      <Sidebar onClose={() => setSidebarOpen(false)} />
      <main className="main">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <div className="content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
